<script lang="ts">
	import { ShopRoutes } from '../../constants/routes';
	import { getGridItems } from '../../pages/ShopCollectionDetailsPage/utils/getGridItems/getGridItems';
	import { MerchItemLabel } from '#lib/websites/merch/components/MerchItemLabel/index.js';
	import { ArtworkCard } from '$global/components/ArtworkCard';
	import { LinkButton } from '$global/components/LinkButton';
	import { Txt } from '$global/components/Txt';
	import type { ShopCollectionDetailsPageData } from '$routes/shop/collections/[slug]/types';

	interface Props {
		merchItems:
			ShopCollectionDetailsPageData['collection']['merch_items'] | undefined;
		books:
			| ShopCollectionDetailsPageData['collection']['publishing_books']
			| undefined;
		slugToExclude: string;
		collectionName: string;
		collectionSlug: string;
	}

	let {
		merchItems,
		books,
		slugToExclude,
		collectionName,
		collectionSlug,
	}: Props = $props();

	let gridItems = $derived(
		getGridItems(merchItems || [], books || [], slugToExclude).slice(0, 4)
	);

	const dataCy = 'more-from-this-collection';
</script>

<div class="mt-10 mb-8 border-b border-gray-200 lg:mt-18"></div>
<div
	class="xs:flex-row xs:items-center xs:gap-8 mb-8 flex flex-col items-start justify-between gap-2"
>
	<Txt variant="h4">More from {collectionName} Collection</Txt>
	<LinkButton
		size="sm"
		dataCy={`${dataCy}-view-collection`}
		href={`${ShopRoutes.Collections}/${collectionSlug}`}
		variant="secondary">view collection</LinkButton
	>
</div>

<div
	class="mb-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:mb-16 lg:grid-cols-4"
>
	{#each gridItems as gridItem}
		<div class="relative col-span-1">
			<ArtworkCard
				{dataCy}
				line1={gridItem.line1}
				line2={gridItem.salePrice ? '' : gridItem.line2}
				line3={gridItem.line3}
				class="relative rounded"
				href={gridItem.href}
				image={gridItem.image}
				alt={gridItem.line1}
			>
				{#snippet line2Snippet()}
					{#if gridItem.salePrice}
						<div class="-mt-1" data-cy={`${dataCy}-artwork-card-line-2`}>
							<Txt variant="label3" component="span" class={'text-gray-700'}>
								{gridItem.salePrice}
							</Txt>
							<Txt
								variant="label3"
								component="span"
								class="text-gray-500 line-through"
							>
								{gridItem.line2}
							</Txt>
						</div>
					{:else}
						<Txt
							variant={'label3'}
							class={'text-gray-700'}
							dataCy={`${dataCy}-artwork-card-line-2`}
						>
							{gridItem.line2}
						</Txt>
					{/if}
				{/snippet}
			</ArtworkCard>
			{#if gridItem.labelText}
				<MerchItemLabel dataCy={`${dataCy}-out-of-stock`}
					>{gridItem.labelText.toUpperCase()}</MerchItemLabel
				>
			{/if}
		</div>
	{/each}
</div>
